export default "__VITE_ASSET__B$dgZqKk__"